import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { RouterModule } from "@angular/router";
import { FormlyModule } from "@ngx-formly/core";
import { BreadcrumbModule } from "@vp/shared/components/breadcrumb";
import { PageMenuModule } from "@vp/shared/components/page-menu";
import { FlexModule } from "@vp/shared/directives/flex";
import { FeaturesModule } from "@vp/shared/features";
import { ContextDisplayModule } from "@vp/shared/pipes/context-display";
import { SpinnerModule } from "@vp/shared/spinner";
import { NgxPermissionsModule } from "ngx-permissions";
import { AdministrationNavComponent } from "./administration-nav.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSidenavModule,
    FormlyModule,
    SpinnerModule,
    ContextDisplayModule,
    BreadcrumbModule,
    PageMenuModule,
    NgxPermissionsModule.forChild(),
    FeaturesModule
  ],
  exports: [AdministrationNavComponent],
  declarations: [AdministrationNavComponent]
})
export class AdministrationNavModule {}
